export enum FileTypes {
  IMAGE = 'image',
  PDF = 'pdf',
  WORD = 'doc',
  EXCEL = 'xls',
  EPS = 'eps',
  AUDIO = 'web-audio',
  DATA = 'data',
  POWERPOINT = 'powerpoint',
  PSD = 'psd',
  AI = 'ai'
}
